export const auth = "AUTH_STORAGE_KEY";
